<template>
  <header :class="{ header: true, head: isHead }">
    <div class="top-line" />
    <div class="d-flex" v-if="isHead">
      <div class="header-main">
        <p class="company-name">
          <span class="font-weight-light">{{ `${className ? className : 'HOME'}` }}</span>
          삼성금융경력컨설팅센터
        </p>
        <div class="life-plan-box">
          <div>
            <div class="life-plan"><span>생애연표</span></div>
            <div class="life-plan-desc">
              <p>
                삼성가족의 또 다른 내일을 열어갑니다.
                <br />
                새로운 꿈과 희망을 응원합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
export default {
  name: 'SummaryHeader',
  props: {
    isHead: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['userNick', 'userEmail', 'className', 'classId']),
  },
}
</script>

<style lang="scss" scoped>
header.head {
  background-image: url('/images/left-top.png') !important;
  background-repeat: no-repeat;
  background-size: 450px;
  background-position: 0px 0px;
  height: 230px;
}

header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 28px;
  background-image: none;

  letter-spacing: -1px;
  .top-line {
    width: 100%;
    height: 16px;
    background-color: #70cae9;
    margin-bottom: 12px;
  }
  .header-main {
    flex: 1;
  }

  .company-name {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 8px 40px 0px 50%;
    text-align: right;
    font-weight: 900;
    font-size: 8px;
    color: #1c5eaa;
    margin-bottom: 4px;
  }
  .life-plan-box {
    float: right;
    width: 50%;
    min-width: 300px;
    height: 60px;
    padding-right: 40px;
    > div {
      padding-top: 4px;
      border-top: 1px solid #1c5eaa;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    span,
    p {
      color: #1c5eaa;
    }
    .life-plan-desc {
      margin-left: 12px;
      padding-left: 12px;
      height: 24px;
      border-left: 1px solid #1c5eaa;
      p {
        font-size: 8px !important;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 14px;
      }
    }
    .life-plan {
      span {
        font-size: 16px;
        font-weight: 900;
      }
    }
  }
}
</style>
